import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import { Skeleton } from '@material-ui/lab';
import { Divider, Backdrop, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { GlobalTheme, TileTheme} from "../../layouts/theme";
import { Context } from "../contexts/siteContext.js";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { Theme } from "../contexts/themeContext.js";
import Card from "../card/card.js";
import CardHeader from "../card/cardHeader.js";
import CardBody from "../card/cardBody.js";
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
        position: "absolute"
    }
}));

export default function RoundChart(props) {
    const classes = useStyles();
    const tileClasses = TileTheme();
    const offlineService = new OfflineService();
    const { defaultSite, siteLoading } = useContext(Context);
    const { theme } = useContext(Theme);
    const [loading, setLoading] = useState(true);
    const [backDrop, setBackDrop] = useState(false);
    const [totalSat, setTotalSat] = useState(0);
    const [totalUnsat, setTotalUnsat] = useState(0);
    const [totalCompleted, setTotalCompleted] = useState(0);
    const [totalConfirmed, setTotalConfirmed] = useState(0);
    const currentTheme = GlobalTheme[theme];

    const getRoundSummary = () => {
        setBackDrop(true);
        HttpService.post("/Round/GetRoundSummary", { Date: new Date(), SiteId: defaultSite.id })
            .then(async (result) => {
                if (result && result.offline) {
                    let offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "RoundSummary");
                    result = offlineResult.OfflineData;
                }
                else {
                    offlineService.removeOfflineBySite(defaultSite.id, "RoundSummary");
                    offlineService.addOffline(defaultSite.id, "RoundSummary", result);
                }

                if (result.data !== null) {
                    setTotalSat(result.data.TotalSat);
                    setTotalUnsat(result.data.TotalUnsat);
                    setTotalCompleted(result.data.TotalComplete);
                    setTotalConfirmed(result.data.TotalConfirmed);
                    setLoading(false);
                    setBackDrop(false);
                }
        },
                (error) => {
                    console.log(error);
                    setBackDrop(false);
                })
    };

    var chartData = {
        labels: ['', ''],
        datasets: [{
            label: 'Sat',
            backgroundColor: '#367CF7',
            data: [totalSat, 0],
            categoryPercentage: 0.5
        }, {
            label: 'Unsat',
            backgroundColor: "#E85B55",
            data: [0, totalUnsat],
            categoryPercentage: 0.5
        }, {
            label: 'Complete',
            backgroundColor: "#138700",
            data: [0, totalCompleted],
            categoryPercentage: 0.5
        }, {
            label: 'Confirmed',
            backgroundColor: "#EAA93C",
            data: [0, totalConfirmed],
            categoryPercentage: 0.5
        }]
    };

    const options = {
        legend: {
            position: 'top',
            display: false,
            align: 'start',
            fullwidth: true,
            labels: {
                boxWidth: 10,
                fontSize: 10
            }
        },
        layout: {
            padding: {
                left: 30,
                right: 30,
                top: 0,
                bottom: -20
            }
        },
        scales: {
            xAxes: [{
                stacked: true,
                ticks: { beginAtZero: true, display: true },
                gridLines: {
                    display: true,
                    drawBorder: true
                }
            }],
            yAxes: [{
                stacked: true,
                ticks: { beginAtZero: true, display: false },
                gridLines: {
                    display: true,
                    drawBorder: true
                }
            }]
        },
        tooltips: {
            displayColors: false,
            titleFontSize: 12,
            bodyFontSize: 12,
            xPadding: 5,
            yPadding: 5
        }
    }

    useEffect(() => {
        if (!siteLoading)
            getRoundSummary();
        // eslint-disable-next-line 
    }, [props.mode, defaultSite, siteLoading]);

    return (<>
        <div style={{ position: "relative" }}>
            <Link to={{ pathname: "/Rounds" }}>
                <Backdrop className={classes.backdrop} id="roundBackdrop" open={backDrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Card chart color="primary" className={tileClasses.card} style={{ background: currentTheme.background, color: currentTheme.text }} >
                    <CardContent className={tileClasses.cardContent}>
                        <CardHeader>
                            <div className={tileClasses.title}>Rounds</div>
                            {loading === true ? (<Skeleton variant="rect" height={76} />) : (
                                <Bar data={chartData} options={options} height={76} />
                            )}
                        </CardHeader>
                        <Divider />
                        <CardBody>
                            <div className={tileClasses.subTitle}>Daily Summary</div>
                            {loading === true ? (<div><Skeleton variant="text" /><Skeleton variant="text" /></div>) : (
                                <div className="d-flex flex-column">
                                    <label className={tileClasses.optionText}><span style={{ background: '#367CF7' }} className={tileClasses.optionBlock}></span>Sat: {totalSat}</label>
                                    <label className={tileClasses.optionText}><span style={{ background: '#E85B55' }} className={tileClasses.optionBlock}></span>Unsat: {totalUnsat}</label>
                                    <label className={tileClasses.optionText}><span style={{ background: '#138700' }} className={tileClasses.optionBlock}></span>Completed: {totalCompleted}</label>
                                    <label className={tileClasses.optionText}><span style={{ background: '#EAA93C' }} className={tileClasses.optionBlock}></span>Confirmed: {totalConfirmed}</label>
                                </div>
                            )}
                        </CardBody>
                    </CardContent>
                </Card>
            </Link>
        </div>
    </>
    );
}
